import { Account } from "@/types/auth";

export const ACCOUNT = [{ queryKey: "ACCOUNT" }];
export const WORKSPACES = [{ queryKey: "WORKSPACES" }];

export interface LoginRequest {
  email: string;
  password: string;
}

export interface RegisterRequest {
  name: string;
  email: string;
}
export interface LoginResponse {
  access: string;
  refresh: string;
  user: Account;
}

export interface ResetPassword {
  token: string;
  password: string;
  repeat_password: string;
}

export interface RefreshTokenRequest {
  refresh: string;
}
export interface RefreshTokenResponse {
  access: string;
  access_token_expiration: string; // ISO 8601
}

export interface StoreLoginRequest {
  shop_token: string;
}

export interface CreateWorkspace {
  name: string;
  slug: string;
}

export interface StoreConnect {
  shop_url: string;
}